function setNativeValue(
  el: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement,
  value: string | boolean
) {
  if (
    el instanceof HTMLInputElement &&
    (el.type === 'checkbox' || el.type === 'radio')
  ) {
    const input = el as HTMLInputElement;
    const shouldCheck = Boolean(value);
    if (input.checked !== shouldCheck) {
      input.checked = shouldCheck;
      // Click fires all the right listeners for check/radio groups
      input.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }

  const proto =
    el instanceof HTMLSelectElement
      ? HTMLSelectElement.prototype
      : el instanceof HTMLTextAreaElement
      ? HTMLTextAreaElement.prototype
      : HTMLInputElement.prototype;

  const desc = Object.getOwnPropertyDescriptor(proto, 'value');
  desc?.set?.call(el, String(value));

  // Fire a burst of events many validators rely on
  el.dispatchEvent(new Event('input', { bubbles: true }));
  el.dispatchEvent(new Event('change', { bubbles: true }));
  el.dispatchEvent(new Event('blur', { bubbles: true }));
  // optional: some setups listen to keyup for “touched”
  el.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'Tab' }));
}

export function fillFormField(
  form: HTMLElement,
  name: string,
  value: string | boolean
) {
  const el = form.querySelector<
    HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
  >(`[name="${name}"]`);
  if (!el) return;
  setNativeValue(el, value);
}
